












































import Vue from 'vue';
import { OpenHelp } from '@/mixins';
import {
  AccountStatus,
  ManagePlan,
  ManageCoverage,
  ManageBeneficiaries,
  ViewAccountNumber,
} from '@/components/account-settings-components/hsa-settings-components';
import { ExtendMixins } from '@/services';
import { MemberAccountResponseModel, UserModel } from '@/@types/member';
import moment from 'moment';
import { dateFormatYYYYMMDD } from '@/constants';

export default ExtendMixins(
  OpenHelp,
).extend({
  name: 'HSASettings',
  props: {
    account: {
      type: Object as () => MemberAccountResponseModel,
      required: true,
    },
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
    isHSA(): boolean {
      return this.account.productType === 'HSA';
    },
    isVEBA(): boolean {
      return this.account.productType === 'VEBA';
    },
    isFSA(): boolean {
      return this.account.productType === 'FSA';
    },
    isHRA(): boolean {
      return this.account.productType === 'HRA';
    },
    pageTitle(): string {
      if (this.isHSA) {
        return this.$options.filters.t([
          'account-settings_title_hsa-settings',
          'global_hsa-settings',
        ]);
      } else if (this.isVEBA) {
        return this.$options.filters.t([
          'account-settings_title_veba-settings',
          'global_veba-settings',
        ]);
      } else if (this.isFSA) {
        return this.$options.filters.t([
          'account-settings_title_fsa-settings',
          'global_fsa-settings',
        ]);
      } else if (this.isHRA) {
        return this.$options.filters.t([
          'account-settings_title_hra-settings',
          'global_hra-settings',
        ]);
      }
    },
    // MBR-050: BR-1.07.a-2, BR-1.07.c-1, BR-1.07.d-1
    showManageStatus(): boolean {
      return this.isVEBA
      || (this.isHSA && (!this.user.blackoutStartDate || moment().isBefore(moment(this.user.blackoutStartDate, dateFormatYYYYMMDD), 'day')))
      || (this.isFSA && (!this.user.fsaBlackoutStartDate || moment().isBefore(moment(this.user.fsaBlackoutStartDate, dateFormatYYYYMMDD), 'day')))
      || (this.isHRA && (!this.user.hraBlackoutStartDate || moment().isBefore(moment(this.user.hraBlackoutStartDate, dateFormatYYYYMMDD), 'day')));
    },
    // MBR-050: BR-1.07a-3, BR-1.07b-2
    showManagePlan(): boolean {
      return (this.isHSA && (!this.user.blackoutStartDate || moment().isBefore(moment(this.user.blackoutStartDate, dateFormatYYYYMMDD), 'day')))
      || this.isVEBA;
    },
    // MBR-050: BR-1.07a-5, BR-1.07b-3
    showManageBeneficiaries(): boolean {
      return this.account.allowBeneficiaryChange && (this.isHSA || this.isVEBA);
    },
    // MBR-050: BR-1.07a-4
    showManageCoverage(): boolean {
      return this.isHSA;
    },
    // MBR-050: BR-1.08
    isSuppressCoverageEdit(): boolean {
      return this.user.isSuppressEnrollment &&
        !this.account.hasManualEnrollment;
    },
  },
  components: {
    AccountStatus,
    ManagePlan,
    ManageCoverage,
    ManageBeneficiaries,
    ViewAccountNumber,
  },
});
